import * as R from 'ramda';

export default function ContributionComponentController(
  $q,
  $rootScope,
  $scope,
  alerts,
  ecatDataService,
  ecatSharedModelService,
  confirmDialog,
  loaderService,
  orgDataService,
  ssDialogService,
  userService,
  serviceIds,
) {
  const vm = this;

  // Set Default Values
  vm.serviceId = serviceIds.ECAT;
  vm.isExpanded = false;

  // Attach Event Handlers
  vm.handleExpand = _handleExpand;

  _activate();

  _initEventListeners();

  // //////// METHODS //////////

  function _activate() {
    userService.getUserPermissionSet('ecat').then((permissions) => {
      vm.permissions = permissions;
    });
    _setLevelCSSName();
  }

  function _initEventListeners() {
    $scope.$on('refreshContributionComponentInformation', (event, opt) => {
      if (opt.contributionComponentId === vm.contributionComponent.contributionComponentId) {
        _refreshContributionComponentInformation();
      }
    });
  }

  function _handleExpand() {
    vm.isExpanded = !vm.isExpanded;
  }

  function _refreshContributionComponentInformation() {
    vm.contributionComponent.level = 0;
    let previousMaturityLevelNotAchieved = false;
    R.forEach((componentLevel) => {
      if ((componentLevel.summaryStatus === 'Achieved') && (!previousMaturityLevelNotAchieved)) {
        vm.contributionComponent.level += 1;
        vm.contributionComponent.levelName = componentLevel.name;
      } else {
        previousMaturityLevelNotAchieved = true;
      }
    }, vm.contributionComponent.componentLevels);
    _setLevelCSSName();
  }

  function _setLevelCSSName() {
    if (vm.contributionComponent.level === 1) {
      vm.levelCSSName = 'fc-hula-skirt-green-100';
    } else if (vm.contributionComponent.level === 2) {
      vm.levelCSSName = 'fc-hula-skirt-green-100';
    } else if (vm.contributionComponent.level === 3) {
      vm.levelCSSName = 'fc-hula-skirt-green-100';
    } else if (vm.contributionComponent.level === 4) {
      vm.levelCSSName = 'fc-hula-skirt-green-100';
    } else if (vm.contributionComponent.level === 5) {
      vm.levelCSSName = 'fc-navanta-plum-100';
    } else {
      vm.levelCSSName = 'fc-navanta-charcoal-100';
    }
  }
}

ContributionComponentController.$inject = [
  '$q',
  '$rootScope',
  '$scope',
  'alerts',
  'ecatDataService',
  'ecatSharedModelService',
  'confirmDialog',
  'loaderService',
  'orgDataService',
  'ssDialogService',
  'userService',
  'serviceIds'
];
